import { SwiperSlide } from "swiper/react";
import Image from "next/image";
import { isStorybook } from "utils/storybookUtils";
import { getStaticFile } from "utils/getStaticFile";

import type { PDPImage } from "@shared/graphql.types";
import { cloudinaryLoader } from "@shared/utils.cloudinary";

export type GalleryImageSlideProps = {
  item: PDPImage;
  index: number;
  thumbsSize?: number | null;
  useCloudinary?: boolean;
  onClick?: () => void;
};

export const GalleryImageSlide: React.FC<GalleryImageSlideProps> = ({
  item,
  index,
  useCloudinary,
  thumbsSize = null,
  onClick
}) => {
  return (
    <SwiperSlide
      key={`full-${index}`}
      data-testid="swiper-slide"
      style={{
        width: thumbsSize ?? "100%",
        height: thumbsSize ?? "100%",
        position: "relative"
      }}
      onClick={() => onClick?.()}
    >
      <Image
        data-testid="next-image"
        src={item?.src ?? ""}
        fill
        alt={item?.alt ?? ""}
        placeholder={index === 0 || isStorybook ? "empty" : "blur"}
        blurDataURL={getStaticFile("/images/placeholder.svg")}
        unoptimized={isStorybook}
        quality={85}
        priority
        sizes="(max-width: 768px) 100vw, (max-width: 1430px) 50vw, 50vw"
        loader={useCloudinary ? cloudinaryLoader : undefined}
      />
    </SwiperSlide>
  );
};

// Slider sucks, https://github.com/nolimits4web/swiper/issues/4413
GalleryImageSlide.displayName = "SwiperSlide";
